// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerReviews__selfBlocked":"gu_a bho_ea bho_va bho_ts bho_vm bho_vh"};